import { browserProvider } from './browser-provider';
import { sampleThisMetric } from './utils';

export const reportNewRelicEvent = (
  event: string,
  attr: Record<string, string | number>,
  samplePercent: number = 25,
) => sampleThisMetric(samplePercent) && browserProvider.getActionReporter()(event, attr);
